// "Cashflow Reconciliation Check" result panel - same CheckResult shape as
// Loan Number Check / Investment Amount Check (preflight.py::CheckResult,
// see check_cashflow_reconciliation_check()), rendered via the shared
// CheckResultCard. Each issue's `field` is the platform and `identifier` is
// the investment_id (see that function) - clicking an issue row opens the
// per-loan drilldown dialog (GET .../cashflow-reconciliation-check/detail).

import React, { useEffect, useState, useCallback } from 'react';
import axiosWithAuth from '../../../helpers/AxiosHelper';
import { readErrorDetail } from '../jobs';
import CheckResultCard from '../CheckResultCard';
import CashflowReconciliationDetailDialog from './CashflowReconciliationDetailDialog';
import LoadingState from '../../common/LoadingState';
import errorMessage from '../../../helpers/errorMessage';

const CashflowReconciliationPanel = ({ reportingId, setLoading, onChange }) => {
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [detailTarget, setDetailTarget] = useState(null); // {platform, investmentId}

  const fetchResult = useCallback(async () => {
    if (!reportingId) return;
    setLoading(true);
    try {
      const res = await axiosWithAuth.get(`/compartment-report/reportings/${reportingId}/cashflow-reconciliation-check/result`);
      setResult(res.data);
      setError(null);
      if (onChange) onChange(res.data);
    } catch (err) {
      console.error('[CashflowReconciliationPanel] fetch error:', errorMessage(err));
      setError(readErrorDetail(err, 'Failed to load cashflow reconciliation check.'));
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportingId]);

  useEffect(() => {
    fetchResult();
  }, [fetchResult]);

  const handleIssueClick = (issue) => {
    setDetailTarget({ platform: issue.field, investmentId: issue.identifier });
  };

  return (
    <div>
      {error && <div className="ex-inline-error mb-3">{error}</div>}
      {!result ? !error && <LoadingState label="Loading cashflow reconciliation check" /> : <CheckResultCard check={result} onIssueClick={handleIssueClick} />}

      <CashflowReconciliationDetailDialog
        reportingId={reportingId}
        visible={!!detailTarget}
        platform={detailTarget?.platform}
        investmentId={detailTarget?.investmentId}
        onHide={() => setDetailTarget(null)}
      />
    </div>
  );
};

export default CashflowReconciliationPanel;
